import React from "react";
import "../css/privacy.scss";

const faqs = [
  ["How can I contact you?", "Email round@pittleforestandco.shop and include your order number where applicable."],
  ["When will my order be dispatched?", "Dispatch and estimated delivery times are shown on our Shipping page. You will receive an update when your order is on its way."],
  ["Can I change or cancel an order?", "Contact us as soon as possible. We cannot guarantee changes after an order has entered fulfilment, but we will always check what is possible."],
  ["What is your returns policy?", "Eligible unused items may be returned in line with the conditions and timeframe on our Returns page."],
  ["What if my order arrives damaged?", "Photograph the item and packaging, then email us promptly with your order number so we can review the issue."],
  ["Are product colours exact?", "We make every effort to present colours accurately, but screens and lighting can cause slight differences."],
  ["How do I care for stationery?", "Keep paper goods dry and away from prolonged direct sunlight. Store pens capped or retracted and use the compatible refill stated on the product page."],
  ["How is my information used?", "Our Privacy Policy explains what we collect, why we use it and the choices available to you."],
];

function Faqs() {
  return (
    <div className="page-width page-width--narrow section-template--27768163107198__main-padding">
      <h1 className="main-page-title page-title h0">Frequently Asked Questions</h1>
      <div className="rte">
        {faqs.map(([question, answer]) => (
          <div key={question} className="policy-block">
            <strong>{question}</strong>
            <p>{answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Faqs;
